//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isNullOrEmpty } from "@nuskin/ns-common-lib";
import {
  getProducts,
  getTranslations,
  getCategoryTranslations
} from "../services/product";
import ProductCard from "./ProductCard.vue";
export default {
  name: "ProductList",
  components: {
    ProductCard
  },
  props: {
    /**
     * IDs of products to add to product list
     */
    productIds: {
      type: Array,
      default: () => []
    },
    /**
     * Number of products displayed per "Show More" button click. Set to 0 to disable.
     */
    countToShowPerClick: {
      type: Number,
      default: 16
    },
    /** Number of products displayed on initial load. */
    initialDisplayCount: {
      type: Number,
      default: 16
    },
    market: {
      type: String,
      default: "US"
    },
    language: {
      type: String,
      default: "en"
    },
    env: {
      type: String,
      default: "test"
    },
    isWholesale: {
      type: Boolean,
      default: false
    },
    /**
     * is-sales-event -> determines if a sales event is going on or not
     */
    isSalesEvent: {
      type: Boolean,
      default: false
    },
    /** use-content-source -> can be either CS for contentstack or Equinox, otherwise will pull from contentstack config map configuration */
    useContentSource: {
      type: String,
      default: null
    },
    /** okta - okta token for equinox */
    okta: {
      type: String,
      default: null
    },
    /** To show "Add To Card" button set it to true */
    showAddToCart: {
      type: Boolean,
      default: false
    },
    /** Number of products to fetch per api call. It's used while fetching all products in the background */
    fetchSizeInTheBackground: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      showSpinner: false,
      productsData: [],
      translationData: {},
      categoryTranslationData: {},
      selectedSortType: null,
      hiddenProducts: [],
      sortOpen: false,
      selectedSortTextVar: "",
      allProductsLoaded: false
    };
  },
  computed: {
    showLoadMore() {
      return (
        !this.showSpinner &&
        !!this.countToShowPerClick &&
        this.hiddenProducts.length > 0
      );
    },
    isProductsExists() {
      return this.productsData && this.productsData.length > 0;
    },
    sortItems() {
      return [
        { text: this.categoryTranslationData.sortbyfeatured, value: "FE" },
        {
          text: this.categoryTranslationData.sortByPriceLowToHigh,
          value: "PL"
        },
        {
          text: this.categoryTranslationData.sortByPriceHightToLow,
          value: "PH"
        },
        { text: this.categoryTranslationData.sortbyatoz, value: "AZ" },
        { text: this.categoryTranslationData.sortbyztoa, value: "ZA" }
      ];
    },
    selectedSortText() {
      return isNullOrEmpty(this.selectedSortTextVar)
        ? this.categoryTranslationData.sortbyfeatured
        : this.selectedSortTextVar;
    },
    totalProductCount() {
      return this.productsData.length + this.hiddenProducts.length;
    }
  },
  watch: {
    productIds: {
      async handler() {
        const initialCount = Math.min(
          this.initialDisplayCount,
          this.productIds.length
        );

        this.showSpinner = true;

        const initialProducts = [];
        let start = 0;
        const fetchSize = this.fetchSizeInTheBackground;

        while (
          initialProducts.length < initialCount &&
          start < this.productIds.length
        ) {
          const pageIds = this.productIds.slice(start, start + fetchSize);
          const pageProducts = await this.getProductsData(pageIds);
          const validProducts = this.getValidProducts(pageProducts);
          this.merge(initialProducts, validProducts);
          start += fetchSize;
        }

        if (initialProducts.length > initialCount)
          this.merge(this.hiddenProducts, initialProducts.slice(initialCount));
        this.merge(this.productsData, initialProducts.slice(0, initialCount));

        this.showSpinner = false;

        const remainingIds = this.productIds.slice(start) || [];

        this.getAllProducts(remainingIds, this.fetchSizeInTheBackground).then(
          remaining => {
            this.merge(this.hiddenProducts, remaining);
            this.allProductsLoaded = true;
            this.setSelectedSortType("FE");
          }
        );
      },
      immediate: true
    }
  },
  created() {
    window.addEventListener("resize", this.screenWidth);
  },
  mounted() {
    this.screenWidth();
    this.getProductTranslations();
    this.getCategoryTranslations();
  },
  destroyed() {
    window.removeEventListener("resize", this.screenWidth);
  },
  methods: {
    setSelectedSortType(newSort) {
      this.sortOpen = false;
      this.selectedSortTextVar = newSort.text;
      const newSortValue = newSort.value;
      if (!this.sortItems.some(option => option.value === newSortValue)) return;
      let sortFn;
      if (newSortValue === "AZ" || newSortValue === "ZA") {
        sortFn = (a, b) => {
          const nameA = this.getProductTitle(a).toUpperCase(); // ignore upper and lowercase
          const nameB = this.getProductTitle(b).toUpperCase(); // ignore upper and lowercase
          let result = 0;
          if (nameA < nameB) {
            result = -1;
          }
          if (nameA > nameB) {
            result = 1;
          }
          return newSortValue === "ZA" ? -1 * result : result;
        };
      } else if (newSortValue === "FE") {
        sortFn = (a, b) => {
          const rankA = a.relevancyRank || Number.MAX_SAFE_INTEGER;
          const rankB = b.relevancyRank || Number.MAX_SAFE_INTEGER;
          return rankA - rankB;
        };
      } else {
        sortFn = (a, b) => {
          let result = this.getProductPrice(a) - this.getProductPrice(b);
          if (newSortValue === "PH") {
            result *= -1;
          }
          return result;
        };
      }
      const displayedCount = this.productsData.length;
      const tmpProducts = [...this.productsData];
      this.merge(tmpProducts, this.hiddenProducts);
      tmpProducts.sort(sortFn);
      this.productsData = tmpProducts.slice(0, displayedCount);
      tmpProducts.splice(0, displayedCount);
      this.hiddenProducts = tmpProducts;
    },
    screenWidth() {
      this.windowWidth = window.innerWidth;
    },
    getProductTitle(product) {
      if (!!product && !!product.variants && product.variants.length > 0) {
        return product.variants[0].title || "";
      }
      return product.title || "";
    },
    getProductPrice(product) {
      // passed in props via priceObject:
      let retail = (product.priceObject || {}).retail || null;
      let retailSales = (product.priceObject || {}).retailSales || null;
      let retailSubscription =
        (product.priceObject || {}).retailSubscription || null;
      let wholesale = (product.priceObject || {}).wholesale || null;
      let wholesaleSales = (product.priceObject || {}).wholesaleSales || null;
      let wholesaleSubscription =
        (product.priceObject || {}).wholesaleSubscription || null;
      // productData - update props if variant or bundle exist from productLib.getProduct() and productLib.getPricing()
      if (product.variants?.length > 0) {
        const selectedVariant = product.variants[0];
        retail =
          (selectedVariant.totalPrice || {}).retail ||
          (selectedVariant.price || {}).retail ||
          null;
        retailSales =
          (selectedVariant.totalPrice || {}).retailSales ||
          (selectedVariant.price || {}).retailSales ||
          null;
        retailSubscription =
          (selectedVariant.totalPrice || {}).retailSubscription ||
          (selectedVariant.price || {}).retailSubscription ||
          null;
        wholesale =
          (selectedVariant.totalPrice || {}).wholesale ||
          (selectedVariant.price || {}).wholesale ||
          null;
        wholesaleSales =
          (selectedVariant.totalPrice || {}).wholesaleSales ||
          (selectedVariant.price || {}).wholesaleSales ||
          null;
        wholesaleSubscription =
          (selectedVariant.totalPrice || {}).wholesaleSubscription ||
          (selectedVariant.price || {}).wholesaleSubscription ||
          null;
      }
      if (!isNullOrEmpty(product.bundle)) {
        const selectedBundle = product.bundle;
        retail = ((selectedBundle || {}).price || {}).retail || null;
        retailSales = ((selectedBundle || {}).price || {}).retailSales || null;
        retailSubscription =
          ((selectedBundle || {}).price || {}).retailSubscription || null;
        wholesale = ((selectedBundle || {}).price || {}).wholesale || null;
        wholesaleSales =
          ((selectedBundle || {}).price || {}).wholesaleSales || null;
        wholesaleSubscription =
          ((selectedBundle || {}).price || {}).wholesaleSubscription || null;
      }
      const price =
        this.isWholesale && this.isSubscription
          ? wholesaleSubscription
          : this.isWholesale && this.isSalesEvent
          ? wholesaleSales
          : this.isWholesale
          ? wholesale
          : this.isSubscription
          ? retailSubscription
          : this.isSalesEvent
          ? retailSales
          : retail;
      return price;
    },
    async getProductsData(requestdProductIds) {
      if (this.market && this.env && this.language) {
        const response = await getProducts(
          requestdProductIds,
          this.market,
          this.language,
          this.useContentSource,
          this.quantity,
          this.okta,
          this.env
        );
        if (response && response.products && response.products.length > 0) {
          const products = await response.products.filter(
            p => p.error === null
          );
          if (products && products.length > 0) {
            return products;
          }
        }
      }
    },
    async getProductTranslations() {
      if (this.market && this.env) {
        const response = await getTranslations(
          this.market,
          this.language,
          this.env
        );
        this.translationData = response;
      }
    },
    async getCategoryTranslations() {
      if (this.market && this.env) {
        const response = await getCategoryTranslations(
          this.market,
          this.language,
          this.env
        );
        if (response) {
          this.categoryTranslationData = response;
        } else {
          const defaultTranslation = await getCategoryTranslations(
            "us",
            "en",
            this.env
          );

          if (defaultTranslation)
            this.categoryTranslationData = defaultTranslation;
        }
      }
    },
    async getAllProducts(requestedProductIds, pageSize) {
      if (!requestedProductIds || requestedProductIds.length === 0) return [];
      const allData = [];
      for (
        let index = 0;
        index < requestedProductIds.length;
        index += pageSize
      ) {
        const productSlice = await this.getProductsData(
          requestedProductIds.slice(index, index + pageSize)
        );
        this.merge(allData, this.getValidProducts(productSlice));
      }
      return allData;
    },
    getValidProducts(products) {
      if (products) {
        return products.filter(
          product =>
            !isNullOrEmpty(this.getProductTitle(product)) &&
            this.getProductPrice(product) > 0
        );
      }
    },
    loadMoreProducts(productCount) {
      this.showSpinner = true;
      this.merge(this.productsData, this.hiddenProducts.slice(0, productCount));
      this.hiddenProducts.splice(0, productCount);
      this.showSpinner = false;
    },
    merge(main, part) {
      if (!part) return;
      for (var i = 0; i < part.length; i++) {
        main.push(part[i]);
      }
    },
    changeSortOpen() {
      this.sortOpen = !this.sortOpen;
    }
  }
};
